<template>
    <div class="rating-button rating-raise">
        <svg class="rating__icon">
            <use xmlns:xlink="http://www.w3.org/1999/xlink" :xlink:href="icon" />
        </svg>
        <div class="rating-button__title">{{ text }}</div>
    </div>
</template>

<script>
export default {
    props: {
        text: {
            type: String
        },
        icon_name: {
            type: String
        }
    },
    computed: {
        icon(){
            return 'icons/sprite.svg#'+this.icon_name;
        }
    }
};
</script>